// src/components/Contact.jsx
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const MAPS_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.2308190270614!2d28.98564997586143!3d41.0639469713428!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab702d0868b0f%3A0x2b1061e7c3dbc4b2!2zS2V5IFBsYXphIMWeacWfbGk!5e0!3m2!1str!2str!4v1754686632817!5m2!1str!2str";

const whatsappLink = "https://wa.me/905551004040";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-[#0b1224] py-8 px-4">
      <div className="max-w-7xl mx-auto"  id="iletisim">
        {/* Başlık */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-5xl font-bold text-[#e8d1b9]">
            {t("contact.title")}
          </h2>
          <p className="text-white/80 mt-2">{t("contact.subtitle")}</p>
        </div>

        {/* GRID: Sol Bilgi/Form - Sağ Harita */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Sol: Bilgi + Form */}
          <div className="rounded-2xl bg-white/10 backdrop-blur-md border border-white/15 shadow-xl p-6">
            <ul className="space-y-4 text-[#e8d1b9]">
              <li className="flex items-start gap-3">
                <span className="text-[#c2a484] mt-1">
                  <FaMapMarkerAlt />
                </span>
                <div className="leading-relaxed">{t("contact.address")}</div>
              </li>
              <li className="flex items-center gap-3">
                <span className="text-[#c2a484]">
                  <FaEnvelope />
                </span>
                <a href={`mailto:${t("contact.email")}`} className="hover:underline">
                  {t("contact.email")}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <span className="text-[#c2a484]">
                  <FaPhoneAlt />
                </span>
                <a href={`tel:${t("contact.phone")}`} className="hover:underline">
                  {t("contact.phone")}
                </a>
              </li>
            </ul>

            {/* Form */}
            <form className="mt-6 space-y-3">
              <input
                type="text"
                placeholder={t("contact.form.name")}
                className="w-full rounded-full bg-white/90 text-[#1a2235] px-5 py-3 outline-none focus:ring-2 focus:ring-[#c2a484]"
              />

              <div className="flex overflow-hidden rounded-full bg-white/90">
                <select
                  className="w-24 sm:w-28 flex-shrink-0 pl-4 pr-3 py-3 text-[#1a2235] bg-transparent border-r border-black/10 outline-none"
                  defaultValue="+90"
                >
                  <option>🇹🇷 +90</option>
                  {/* diğer ülkeler eklenebilir */}
                </select>

                <input
                  type="tel"
                  placeholder={t("contact.form.phone")}
                  className="flex-1 min-w-0 px-5 py-3 bg-transparent text-[#1a2235] outline-none"
                  inputMode="tel"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[#c2a484] to-[#e8d1b9] text-[#1a2235] font-semibold rounded-full py-3 hover:scale-[1.02] transition"
              >
                {t("contact.form.submit")}
              </button>
            </form>

            {/* CTA Butonları */}
            <div className="mt-4 flex flex-wrap gap-3">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 min-w-[150px] text-center rounded-full bg-[#10182b] hover:bg-[#283251] text-white py-3 border border-white/15 transition"
              >
                {t("contact.cta.whatsapp")}
              </a>
              <a
                href="https://maps.google.com/?q=Key Plaza Şişli, İstanbul"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 min-w-[150px] text-center rounded-full bg-white/15 hover:bg-white/25 text-white py-3 border border-white/15 transition"
              >
                {t("contact.cta.directions")}
              </a>
            </div>
          </div>

          {/* Sağ: Harita */}
          <div className="rounded-[28px] overflow-hidden shadow-2xl ring-1 ring-white/10 h-[400px] lg:h-auto">
            <iframe
              title={t("contact.title")}
              src={MAPS_EMBED_URL}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full border-0"
              style={{ filter: "grayscale(10%) contrast(105%) saturate(110%)" }}
            />
          </div>
        </div>

        {/* Alt Bilgi Satırı */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 text-white/80">
          <div className="rounded-xl bg:white/5 bg-white/5 border border-white/10 p-4">
            <div className="text-sm">{t("contact.hours.label")}</div>
            <div className="mt-1 font-semibold">{t("contact.hours.value")}</div>
          </div>
          <div className="rounded-xl bg-white/5 border border-white/10 p-4">
            <div className="text-sm">{t("contact.social")}</div>
            <div className="mt-2 flex gap-4 text-xl text-[#c2a484]">
              <a href="#" className="hover:text-[#e8d1b9]">
                <FaInstagram />
              </a>
              <a href="#" className="hover:text-[#e8d1b9]">
                <FaFacebookF />
              </a>
              <a href="#" className="hover:text-[#e8d1b9]">
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
